module.exports = __webpack_public_path__ + "img/list4.aac4ce66.png";